module.exports = __webpack_public_path__ + "img/Group-32706-1-1.09cb330f.png";